import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";

import VLFTextField from "@/components/Input/TextField";
import LoadingButton from "@mui/lab/LoadingButton";

import {AuthorizationAPI} from "@/api/authorization";

import {loginSuccess} from "@/actions";
import Logo from "@/assets/images/logo.png";

function LoginPage(props) {
	const {handleNotification} = props;

	const dispatch = useDispatch();
	const navigate = useNavigate();

	const isLoggedIn = useSelector((state) => state.isLoggedIn);

	useEffect(() => {
		if (isLoggedIn) {
			navigate("/");
		}
	}, [isLoggedIn, navigate]);

	const [formData, setFormData] = useState({username: "", password: ""});
	const [loading, setLoading] = useState(false);
	// const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState(false);

	// const handleClickShowPassword = () => setShowPassword((show) => !show);
	// const handleMouseDownPassword = (event) => {
	// 	event.preventDefault();
	// };

	const handleLogin = async () => {
		setLoading(true);
		try {
			const response = await AuthorizationAPI.login(formData);
			dispatch(loginSuccess(response.token));
			localStorage.setItem("token", response.token);
			navigate("/");
		} catch (error) {
			setError(true);
			handleNotification("Username e/o password non corretti", "error");
		} finally {
			setLoading(false);
		}
	};

	const handleChange = (event) => {
		const {name, value} = event.target;
		setError(false);
		setFormData({...formData, [name]: value});
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		handleLogin();
	};

	return (
		<div className="login-page-container">
			<div className="login-gradient" />
			<div className="login-pattern" />
			<div className="login-card">
				<div className="login-hero">
					<div className="hero-pill">Goalplayers Lab</div>
					<h1>Accedi alla tua area squadra</h1>
					<p>
						Organizza convocazioni, allenamenti e report in un’unica piattaforma
						semplice e veloce.
					</p>
					<ul className="hero-list">
						<li>Calendari e convocazioni sempre aggiornati</li>
						<li>Statistiche e analisi condivise con lo staff</li>
						<li>Accesso sicuro per ogni ruolo della società</li>
					</ul>
				</div>
				<div className="login-form">
					<div className="logo-wrapper">
						<img className="logo" src={Logo} alt="Football Youth Manager" />
					</div>
					<div className="form-headline">
						<h2>Bentornato</h2>
						<p>Entra con il tuo account per continuare.</p>
					</div>
					<form onSubmit={handleSubmit} className="form-fields">
						<VLFTextField
							name="username"
							value={formData.username}
							onChange={handleChange}
							label="Username"
							size="small"
							required
							onlyLabel
							error={error}
						/>
						<VLFTextField
							name="password"
							value={formData.password}
							onChange={handleChange}
							type="password"
							label="Password"
							size="small"
							required
							onlyLabel
							error={error}
						/>
						{error ? (
							<div className="error-copy">
								Controlla username e password e riprova.
							</div>
						) : null}
						<div className="form-action">
							<LoadingButton
								fullWidth
								type="submit"
								variant="contained"
								size="large"
								loading={loading}
							>
								Accedi
							</LoadingButton>
						</div>
					</form>
				</div>
			</div>
		</div>
	);
}

export default LoginPage;
